import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery"; // Import useMediaQuery
import Box from "@mui/material/Box";
//import { Chip } from '@mui/material';
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Home from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LogoutIcon from "@mui/icons-material/Logout";
import { Outlet, useNavigate } from "react-router-dom";
import MenuEntry from "../menu/MenuEntry";
import MenuSearch from "../menu/MenuSearch";
import MenuUtilities from "../menu/MenuUtilities";
import MenuAdmin from "../menu/MenuAdmin";
import "../css/color.css";
import TokenService from "../service/TokenService";
import MenuReports from "../menu/MenuReports";
import { useAuthentication } from "../customHook/useAuthentecation";
import logo from "../photo/logo.jpg";
import { Typography } from "@mui/material";

const drawerWidth = 240;


const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexGrow: 1,
  minWidth: 0,
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",

  padding: theme.spacing(0.75),

  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  marginLeft: `-${drawerWidth}px`,

  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),

    marginLeft: 0,
  }),

  overflowX: "hidden",

  [theme.breakpoints.down("sm")]: {
    marginLeft: `-${drawerWidth}px`,
    padding: theme.spacing(0.5),

    ...(open && {
      marginLeft: 0,
    }),
  },
}));


const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,

  transition: theme.transitions.create(
    ["margin", "width"],
    {
      easing: theme.transitions.easing.sharp,
      duration:
        theme.transitions.duration.leavingScreen,
    }
  ),

  background:
    "linear-gradient(135deg,#0D47A1 0%,#1565C0 48%,#1976D2 100%) !important",

  color: "#ffffff",

  boxShadow:
    "0 4px 18px rgba(13,71,161,0.22)",

  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,

    transition: theme.transitions.create(
      ["margin", "width"],
      {
        easing: theme.transitions.easing.easeOut,
        duration:
          theme.transitions.duration.enteringScreen,
      }
    ),
  }),

  [theme.breakpoints.down("sm")]: {
    ...(open && {
      width: "100%",
      marginLeft: 0,
    }),
  },
}));


const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  padding: theme.spacing(0, 1),

  ...theme.mixins.toolbar,

  justifyContent: "flex-end",

  background:
    "linear-gradient(135deg,#0D47A1,#1565C0)",

  color: "#ffffff",
}));


export default function PersistentDrawerLeft() {
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const role = tokenServiceDetails?.role;
  //const fullname = tokenServiceDetails?.FullName;
  const consignee = tokenServiceDetails?.consignee || "";
  const urights = tokenServiceDetails?.userrights;

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const { clearAuth } = useAuthentication();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if the viewport is mobile

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    clearAuth();
    navigate("/");
  };

  const handleNavigation = (path) => {
    navigate(path);
    handleDrawerClose();
  };

  // React.useLayoutEffect(() => {
  //   document.body.style.background =
  //     "linear-gradient(to right, #000000, #000fff)";
  // }, []);

 React.useLayoutEffect(() => {
    document.body.style.background =
      "#d7def3ff";
  }, []);


 return (
  <Box
    sx={{
      display: "flex",
      width: "100%",
      minWidth: 0,
      maxWidth: "100%",
      minHeight: "100vh",

      background:
        "linear-gradient(135deg,#f4f8ff 0%,#eef5ff 55%,#f8fbff 100%)",

      overflowX: "hidden",
    }}
  >
    <CssBaseline />

    {/* =====================================================
        TOP APP BAR
    ===================================================== */}

    <AppBar position="fixed" open={open}>
      <Toolbar
        sx={{
          minHeight: {
            xs: "58px !important",
            sm: "64px !important",
          },

          px: {
            xs: 1,
            sm: 2,
          },

          gap: 1,

          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* MENU BUTTON */}

        <IconButton
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            mr: {
              xs: 0.5,
              sm: 1.5,
            },

            color: "#ffffff",

            ...(open && {
              display: "none",
            }),

            background:
              "rgba(255,255,255,0.10)",

            "&:hover": {
              background:
                "rgba(255,255,255,0.18)",
            },
          }}
        >
          <MenuIcon />
        </IconButton>


        {/* =================================================
            LOGO
        ================================================= */}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",

            width: {
              xs: "95px",
              sm: "130px",
              md: "155px",
            },

            flexShrink: 0,

            p: 0.4,

            borderRadius: "8px",

            background:
              "rgba(255,255,255,0.96)",

            boxShadow:
              "0 3px 12px rgba(0,0,0,0.12)",

            boxSizing: "border-box",
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              width: "100%",
              height: "auto",

              maxHeight: {
                xs: "38px",
                sm: "44px",
              },

              display: "block",

              objectFit: "contain",

              borderRadius: "5px",
            }}
          />
        </Box>


        {/* =================================================
            SYSTEM TITLE
        ================================================= */}

        <Box
          sx={{
            display: {
              xs: "none",
              md: "flex",
            },

            flexDirection: "column",

            ml: 1,

            minWidth: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: 800,

              color: "#ffffff",

              lineHeight: 1.2,

              whiteSpace: "normal",
            }}
          >
            Non-Stock Management System
          </Typography>

          <Typography
            sx={{
              fontSize: "10px",

              color:
                "rgba(255,255,255,0.78)",

              mt: 0.3,
            }}
          >
            Mechanical Workshop, Gorakhpur
          </Typography>
        </Box>


        {/* =================================================
            USER INFORMATION
        ================================================= */}

        <Box
          sx={{
            display: "flex",

            alignItems: "center",

            justifyContent: "flex-end",

            gap: {
              xs: 0.5,
              sm: 1,
            },

            ml: "auto",

            minWidth: 0,

            maxWidth: {
              xs: "calc(100% - 115px)",
              sm: "65%",
              md: "60%",
            },

            overflow: "hidden",
          }}
        >
          {/* ROLE */}

          <Box
            sx={{
              display: {
                xs: "none",
                sm: "flex",
              },

              alignItems: "center",

              px: 1.2,
              py: 0.55,

              borderRadius: "20px",

              background:
                "rgba(255,255,255,0.12)",

              border:
                "1px solid rgba(255,255,255,0.18)",

              whiteSpace: "nowrap",
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  sm: "10px",
                  md: "11px",
                },

                fontWeight: 700,

                color: "#ffffff",
              }}
            >
              Role: {role}
            </Typography>
          </Box>


          {/* USER */}

          <Box
            sx={{
              display: "flex",

              alignItems: "center",

              minWidth: 0,

              px: {
                xs: 0.8,
                sm: 1.2,
              },

              py: 0.55,

              borderRadius: "20px",

              background:
                "rgba(255,255,255,0.12)",

              border:
                "1px solid rgba(255,255,255,0.18)",
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "9px",
                  sm: "10px",
                  md: "11px",
                },

                fontWeight: 700,

                color: "#ffffff",

                overflow: "hidden",

                textOverflow: "ellipsis",

                whiteSpace: "nowrap",

                maxWidth: {
                  xs: "75px",
                  sm: "130px",
                  md: "180px",
                },
              }}
            >
              User: {uname}
            </Typography>
          </Box>


          {/* CONSIGNEE */}

          {consignee && consignee.length < 8 && (
            <Box
              sx={{
                display: {
                  xs: "none",
                  md: "flex",
                },

                alignItems: "center",

                px: 1.2,
                py: 0.55,

                borderRadius: "20px",

                background:
                  "rgba(255,255,255,0.12)",

                border:
                  "1px solid rgba(255,255,255,0.18)",

                whiteSpace: "nowrap",
              }}
            >
              <Typography
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#ffffff",
                }}
              >
                Consignee: {consignee}
              </Typography>
            </Box>
          )}
        </Box>
      </Toolbar>
    </AppBar>


    {/* =====================================================
        DRAWER
    ===================================================== */}

    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,

        "& .MuiDrawer-paper": {
          width: drawerWidth,

          boxSizing: "border-box",

          borderRight:
            "1px solid #dce7f5",

          background:
            "linear-gradient(180deg,#ffffff 0%,#f7faff 100%)",

          boxShadow:
            "5px 0 25px rgba(13,71,161,0.08)",

          overflowX: "hidden",
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      {/* =================================================
          DRAWER HEADER
      ================================================= */}

      <DrawerHeader>
        <Box
          sx={{
            flex: 1,

            display: "flex",

            justifyContent: "flex-start",

            alignItems: "center",

            pl: 1,
          }}
        >
          <Typography
            sx={{
              color: "#ffffff",

              fontSize: "14px",

              fontWeight: 800,
            }}
          >
            Main Menu
          </Typography>
        </Box>

        <IconButton
          onClick={handleDrawerClose}
          sx={{
            color: "#ffffff",

            "&:hover": {
              background:
                "rgba(255,255,255,0.14)",
            },
          }}
        >
          {theme.direction === "ltr" ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </DrawerHeader>

      <Divider />


      {/* =================================================
          DASHBOARD
      ================================================= */}

      <ListItem
        disablePadding
        onClick={() =>
          handleNavigation("/dashboard")
        }
      >
        <ListItemButton
          sx={{
            mx: 0.7,
            my: 0.35,

            borderRadius: "10px",

            color: "#263238",

            "&:hover": {
              background:
                "linear-gradient(90deg,#e8f1ff,#f4f8ff)",
            },

            "&:hover .MuiListItemIcon-root": {
              color: "#1565C0",
            },

            "&:hover .MuiListItemText-primary": {
              color: "#1565C0",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 42,
              color: "#1565C0",
            }}
          >
            <Home />
          </ListItemIcon>

          <ListItemText
            primary="Dashboard"
            primaryTypographyProps={{
              fontSize: "13px",
              fontWeight: 600,
            }}
          />
        </ListItemButton>
      </ListItem>

      <Divider sx={{ borderColor: "#e3ebf5" }} />


      {/* =================================================
          ENTRY MENU
      ================================================= */}

      <MenuEntry
        handleNavigation={handleNavigation}
      />

      <Divider sx={{ borderColor: "#e3ebf5" }} />


      {/* =================================================
          ADMIN MENU
      ================================================= */}

      {(urights === 1 || urights === 2) && (
        <>
          <MenuAdmin
            handleNavigation={handleNavigation}
          />

          <Divider
            sx={{
              borderColor: "#e3ebf5",
            }}
          />
        </>
      )}


      {/* =================================================
          REPORTS
      ================================================= */}

      <MenuReports
        handleNavigation={handleNavigation}
      />

      <Divider
        sx={{
          borderColor: "#e3ebf5",
        }}
      />


      {/* =================================================
          SEARCH
      ================================================= */}

      <MenuSearch
        handleNavigation={handleNavigation}
      />

      <Divider
        sx={{
          borderColor: "#e3ebf5",
        }}
      />


      {/* =================================================
          UTILITIES
      ================================================= */}

      <MenuUtilities
        handleNavigation={handleNavigation}
      />

      <Divider
        sx={{
          borderColor: "#e3ebf5",
        }}
      />


      {/* =================================================
          LOGOUT
      ================================================= */}

      <ListItem disablePadding>
        <ListItemButton
          onClick={handleLogout}
          sx={{
            mx: 0.7,
            my: 0.35,

            borderRadius: "10px",

            color: "#d32f2f",

            "&:hover": {
              background:
                "linear-gradient(90deg,#fff3f3,#fff8f8)",
            },

            "&:hover .MuiListItemIcon-root": {
              color: "#c62828",
            },

            "&:hover .MuiListItemText-primary": {
              color: "#c62828",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 42,
              color: "#d32f2f",
            }}
          >
            <LogoutIcon />
          </ListItemIcon>

          <ListItemText
            primary="Logout"
            primaryTypographyProps={{
              fontSize: "13px",
              fontWeight: 700,
            }}
          />
        </ListItemButton>
      </ListItem>

      <Divider
        sx={{
          borderColor: "#e3ebf5",
        }}
      />
    </Drawer>


    {/* =====================================================
        MAIN CONTENT
    ===================================================== */}

    <Main open={open}>
      <DrawerHeader />

      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,

          boxSizing: "border-box",

          overflowX: "hidden",
        }}
      >
        <Outlet />
      </Box>
    </Main>
  </Box>
);
}
